import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "addButton", "toggle"]

  connect() {
    this.updateReminderIndices()
    // Initial check for toggle state
    if (this.hasToggleTarget && this.toggleTarget.checked) {
      this.containerTarget.classList.remove('hidden');
      this.addButtonTarget.classList.remove('hidden');
      if (this.containerTarget.querySelectorAll('.reminder-field:not([style*="display: none"])').length === 0) {
        this.add({ preventDefault: () => {} });
      }
    } else {
      this.containerTarget.classList.add('hidden');
      this.addButtonTarget.classList.add('hidden');
    }
  }

  toggleReminders(event) {
    const isActive = event.target.checked;
    
    this.containerTarget.classList.toggle('hidden', !isActive);
    this.addButtonTarget.classList.toggle('hidden', !isActive);
    
    if (!isActive) {
      this.containerTarget.querySelectorAll('.reminder-field').forEach(field => {
        const idField = field.querySelector('input[name$="[id]"]');
        const destroyField = field.querySelector('input[name$="[_destroy]"]');
        if (idField && idField.value !== "") { // Persisted record
          if (destroyField) {
            destroyField.value = "1";
            field.style.display = "none";
          }
        } else { // New, unpersisted record
          field.remove();
        }
      });
    } else {
      // If container is visible and no reminders are visible (or exist and not marked for destruction), add one.
      let visibleRemindersCount = 0;
      this.containerTarget.querySelectorAll('.reminder-field').forEach(rf => {
        const df = rf.querySelector('input[name$="[_destroy]"]');
        if (!df || df.value !== '1') {
          if (rf.style.display !== 'none') {
             visibleRemindersCount++;
          }
        }
      });

      if (visibleRemindersCount === 0) {
        this.add({ preventDefault: () => {} });
      }
    }
    this.updateReminderIndices();
  }

  add(event) {
    event.preventDefault();
    
    const template = document.getElementById('reminder-template');
    if (!template) {
      console.error("Template 'reminder-template' non trouvé");
      return;
    }
    
    const clone = template.content.cloneNode(true);
    const timestamp = new Date().getTime();
    
    clone.querySelectorAll('[id*="NEW_RECORD"], [name*="NEW_RECORD"]').forEach((el) => {
      el.id = el.id.replace('NEW_RECORD', timestamp);
      el.name = el.name.replace('NEW_RECORD', timestamp);
    });
    
    // Ensure _destroy is set to false for new records
    const destroyField = clone.querySelector('input[name$="[_destroy]"]');
    if (destroyField) {
      destroyField.value = "false";
    }

    this.containerTarget.querySelector(".reminders-list").appendChild(clone);
    this.updateReminderIndices();
  }

  remove(event) {
    event.preventDefault();
    const field = event.target.closest('.reminder-field');
    const idField = field.querySelector('input[name$="[id]"]');
    const destroyField = field.querySelector('input[name$="[_destroy]"]');

    if (idField && idField.value !== "") { // It's a persisted record
      if (destroyField) {
        destroyField.value = "1";
        field.style.display = "none"; // Hide it
      }
    } else { // It's a new, unpersisted record
      field.remove(); // Remove it from the DOM
    }
    this.updateReminderIndices();
  }

  updateReminderIndices() {
    const fields = this.containerTarget.querySelectorAll(".reminder-field:not([style*='display: none'])");
    fields.forEach((field, i) => {
      const indexSpan = field.querySelector('.reminder-index');
      if (indexSpan) {
        indexSpan.textContent = i + 1;
      }
    });
  }
}